import { useFrame } from '@react-three/fiber';
import React from 'react';
import { CanvasTexture, UVMapping, RepeatWrapping, NearestFilter } from 'three';
import { ShipEntity } from './game';

// we need a canvas to render the life bar

function getCanvas() {
  const canvas = document.createElement('canvas');
  canvas.width = 120;
  canvas.height = 5;
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  let lastLifeBarWidth = canvas.width;
  function draw(livesLeft = 3) {
    ctx.fillStyle = '#bf262b';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = '#1b9e28';

    const lifePerUnit = canvas.width / 3;
    const lifeBarWidth = Math.floor(lifePerUnit * livesLeft);
    if (lifeBarWidth < lastLifeBarWidth) {
      ctx.fillRect(0, 0, (lastLifeBarWidth -= 1), canvas.height);
    } else {
      ctx.fillRect(0, 0, Math.floor(lifePerUnit * livesLeft), canvas.height);
    }

    ctx.strokeStyle = 'yellow';
    ctx.lineWidth = 1;
    ctx.strokeRect(0, 0, canvas.width, canvas.height);
  }

  draw();
  const texture = new CanvasTexture(
    ctx.canvas,
    UVMapping,
    RepeatWrapping,
    RepeatWrapping,
    NearestFilter,
    NearestFilter,
  );

  return {
    texture,
    canvas,
    step: (lives = 3) => {
      draw(lives);
      texture.needsUpdate = true;
    },
  };
}

const { texture, step } = getCanvas();

export default function LifeBar({
  ship,
  meshRef,
}: {
  ship: ShipEntity;
  meshRef: any;
}) {
  useFrame(() => {
    step(ship.lives);
  });
  return (
    <mesh ref={meshRef} rotation={[1, 0, 0]} position={[0, -1, -5]}>
      <planeBufferGeometry args={[100, 4]} />
      <meshStandardMaterial transparent map={texture} attach="material" />
    </mesh>
  );
}
